import { render, staticRenderFns } from "./SocialLearningOverflowMenuMyPost.vue?vue&type=template&id=30cc2398&scoped=true&"
import script from "./SocialLearningOverflowMenuMyPost.vue?vue&type=script&lang=js&"
export * from "./SocialLearningOverflowMenuMyPost.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningOverflowMenuMyPost.vue?vue&type=style&index=0&id=30cc2398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc2398",
  null
  
)

export default component.exports